<div class="bg-[#1f2937] border border-gray-700 rounded-lg p-6 h-full">
  <div class="flex items-center justify-between">
    <div>
      <p class="text-gray-400 text-sm">{{ label() }}</p>
      <p class="text-2xl text-white">
        {{ value() + (type() === 'PCT_COMPLETED' ? '%' : '') }}
      </p>
    </div>

    <div
      class="{{ getIconConfig().bgClass }} w-12 h-12 rounded-lg flex items-center justify-center"
    >
      @switch (type()) {
        @case ('TOTAL') {
          <div>
            <svg
              class="text-[#00A4D6] w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              ></path>
            </svg>
          </div>
        }
        @case ('COMPLETED') {
          <div>
            <svg
              class="text-green-500 w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
        }
        @case ('PCT_COMPLETED') {
          <div>
            <svg
              class="text-[#ff4f66] w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z"
              ></path>
            </svg>
          </div>
        }

        @case ('NUM_CRITERIA') {
          <div>
            <svg
              class="text-blue-500 w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
              ></path>
            </svg>
          </div>
        }
        @case ('NUM_SUB_CRITERIA') {
          <div>
            <svg
              class="text-purple-500 w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
              ></path>
            </svg>
          </div>
        }
      }
    </div>
  </div>
  @if (type() === 'PCT_COMPLETED') {
    <div class="mt-3">
      <p-progressBar
        [showValue]="false"
        [class]="value() === 100 ? 'completed-progress' : ''"
        [style]="{height: '6px'}"
        [value]="value()"
      ></p-progressBar>
    </div>
  }
</div>
